export { default, HighlightText } from './HighlightText';
export type { HighlightTextProps } from './HighlightText';
